import React, { useState } from 'react'
import { setConfig } from 'react-hot-loader'

setConfig({ pureSFC: true })

export const ModalContext = React.createContext()

const ModalProvider = ({ children }) => {
  const [activeForm, setActiveForm] = useState(null)
  // Holds value so as to prefill in login form
  const [signupEmail, setSignupEmail] = useState('')

  const setActive = formId => setActiveForm(formId)
  const setEmail = email => setSignupEmail(email)

  return (
    <ModalContext.Provider
      value={{ activeForm, setActive, signupEmail, setEmail }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export default ModalProvider
